import { SortQueryDirection } from "@ds-cps/ui";

import { AuditLogModelKeys, FilterOptionsByForAuditLog } from "../models";

export class CreateParamsForAuditLog extends URLSearchParams {
  withPagination(pageSize: number, pageIndex?: number) {
    this.append("pageSize", pageSize.toString());

    if (pageIndex !== undefined) {
      this.append("offset", (pageIndex * pageSize).toString());
    }
  }

  withSortBy(activeSort: AuditLogModelKeys) {
    if (activeSort) {
      this.append("sortBy", activeSort);
    }
  }

  withSortDirection(sortDirection: SortQueryDirection) {
    if (sortDirection) {
      this.append("sortDirection", `${sortDirection}`);
    }
  }

  withFilterOptions(filterOptions?: FilterOptionsByForAuditLog) {
    if (filterOptions) {
      const { dateRangeFilter } = filterOptions;

      if (dateRangeFilter) {
        const [from, to] = dateRangeFilter as [Date, Date];

        if (from) {
          this.append("fromDateTime", new Date(from).toISOString());
        }
        if (to) {
          this.append("toDateTime", new Date(to).toISOString());
        }
      }
    }
  }
}
